<div #definedError class="exception-error">
  <h1 mat-dialog-title>
    @if (titleMatIconLigText) {
      <mat-icon class="material-icons">
        {{ titleMatIconLigText }}
      </mat-icon>
    }
    {{ title }}
  </h1>

  <mat-dialog-content>
    @if (errorDescription) {
      <p [innerHTML]="errorDescription"></p>
    }
    @if (codes && codes.length) {
      <code>
        @for (code of codes; track $index) {
          <pre>{{ code }}</pre>
        }
      </code>
    }
  </mat-dialog-content>
</div>
<mat-dialog-actions>
  <div class="d-flex end">
    <button mat-raised-button color="accent" (click)="close()">Fermer</button>
  </div>
</mat-dialog-actions>
